import React from 'react';
import {
    Button,
} from 'antd';
import { FaPlusCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function CreateButton({ linkTo }) {
    const navigate = useNavigate();

    return (
        <Button
            type='primary'
            icon={<FaPlusCircle />}
            onClick={() => navigate(linkTo)}
        >Add</Button>
    )
}

export default CreateButton